import { Navigate, Outlet, createBrowserRouter } from 'react-router-dom'

import AuthGuard from 'routes/AuthGuard'
import Loadable from 'components/Loadable'
import MainLayout from 'layout/MainLayout'
import config from 'config'
import EntryLoadingPage from 'views/entry-loading'
import { lazy } from 'react'

const RootOutlet = () => <Outlet />

// Views
const ArchivesPage = Loadable(lazy(() => import('views/archives')))
const TasksPage = Loadable(lazy(() => import('views/tasks')))
const DataExplorerPage = Loadable(lazy(() => import('views/explorer')))
const PointTasking = Loadable(lazy(() => import('views/point-tasking')))

const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <RootOutlet />,
      children: [
        { index: true, element: <Navigate to="/landing" replace /> },
        { path: 'landing', element: <EntryLoadingPage /> },
        {
          element: <AuthGuard />,
          children: [
            {
              element: <MainLayout />,
              children: [
                { path: 'navigator', element: <DataExplorerPage /> },
                { path: 'scenes', element: <ArchivesPage /> },
                { path: 'jobs-queue', element: <TasksPage /> },
                { path: 'point-tasking', element: <PointTasking /> },
                { path: 'repositories', element: <ArchivesPage /> },
                { path: 'repositories/:id/scenes', element: <ArchivesPage /> }
              ]
            }
          ]
        }
      ]
    }
  ],
  { basename: config.basename }
)

export default router
